<template>
  <div class="notfound">
    404,您的页面路径有误！
  </div>
</template>
<script>
export default {};
</script>
<style>
.notfound {
  height: 100px;
  line-height: 100px;
  color: red;
  text-align: center;
  font-size: 30px;
}
</style>

